import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  LocalShipping as ShippingIcon,
  Replay as ReturnsIcon,
  Lock as SecureIcon,
  VerifiedUser as SafeIcon
} from '@mui/icons-material';

const badges = [
  { icon: <ShippingIcon fontSize="small" />, label: 'Free Shipping' },
  { icon: <ReturnsIcon fontSize="small" />, label: '7-Day Returns' },
  { icon: <SecureIcon fontSize="small" />, label: 'Secure Checkout' },
  { icon: <SafeIcon fontSize="small" />, label: 'Skin-Friendly' }
];

const TrustBadges: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: { xs: 2, sm: 3 },
        flexWrap: 'wrap',
        justifyContent: 'center',
        py: 2,
        px: 1,
        borderRadius: 3,
        bgcolor: 'rgba(214, 90, 136, 0.04)',
        border: '1px solid rgba(214, 90, 136, 0.1)'
      }}
    >
      {badges.map((badge) => (
        <Box
          key={badge.label}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.75,
            color: 'text.secondary'
          }}
        >
          {badge.icon}
          <Typography variant="caption" sx={{ fontWeight: 500 }}>
            {badge.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default TrustBadges;
